const ngModule = angular.module('ppa.filters.url', []);

ngModule.filter('url', ['$sce', function($sce) {
    return function(Url) {
        return $sce.trustAsResourceUrl(Url);
    };
}]);